import React from "react";

import * as Constants from "../../../../../consts/Constants.js";
import { Grid } from "@material-ui/core";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CancelIcon from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Typography } from "@material-ui/core";

import Style from "../../../../../styles/js/StyleCallList.js";

import { Configuration } from '../../../../../plas/services/calls/models';
import service from '../../../../../plas/services/calls/service';
import alerter from "../../../../alerts/alerter"

export default function ConfigurationCreationForm( { open, cancel, created } ) {

	const theme = createTheme({
	  palette: {
	    primary: {
	      main: '#FFFFFF',
	      darker: '#FFFFFF',
	    }
	  },
	});
	const style = Style();

  	const [creating, setCreating] = React.useState(false);
  	const [configuration, setConfiguration] = React.useState(new Configuration());
  	
	React.useEffect(() => {
		if (open) {
			setConfiguration(new Configuration());
			setCreating(false);
		}
	}, [open]);

  	const create = () => {
  		setCreating(true);
  		service.api.configurations.create(configuration, (response) => {
  			if (response.result != null) {
  				created(response.result);
  			} else {
  				alerter.showError(response.error);
  			}
  			setCreating(false);
  		});
  	}

	return(
		<div>
		 	<Dialog open={open} fullWidth maxWidth="md">
		        <DialogTitle style={{background: Constants.COLOR_PRIMARY, color: 'white' }}>
		          <Typography className={style.titleInitial}>
		            Nuevo formulario
		          </Typography>
		        </DialogTitle>
		        <DialogContent style={{ paddingTop: '16px', paddingBottom: '16px' }}>
		        	<div className={style.box} >
						<Grid container alignItems="center" spacing={2}>
							<Grid item xs={12}>
						      	<TextField
						      		disabled={creating}
					                variant="outlined" 
					                id="name"
					                label="Nombre"
					                name="name"
					                onChange={ (event) => {
					                	configuration.name = event.target.value;
					                	setConfiguration(new Configuration(configuration));
					                }}
					                fullWidth
					                placeholder="Nombre del formulario"/>
				            </Grid>
				            <Grid item xs={12}>
						      	<TextField
						      		disabled={creating}
					                variant="outlined" 
					                id="name"
					                label="Descripción"
					                name="description"
					                onChange={ (event) => {
					                	configuration.description = event.target.value;
					                	setConfiguration(new Configuration(configuration));
					                }}
					                multiline
					                fullWidth
					                placeholder="Breve descripción del formulario"/>
				            </Grid>
						</Grid>
					</div>
		        </DialogContent>
		        <DialogActions style={{background: Constants.COLOR_GRAY_ULTRA_LIGHT, color: 'white' }}>
		          <ThemeProvider theme={theme}>
		            <Button 
		            	disabled={creating} 
		            	startIcon={<CancelIcon/>} 
		            	variant="contained" 
		            	onClick={() => cancel()}>
		            	Cancelar
		            </Button>
		            <LoadingButton
				        loading={creating}
				        disabled={!configuration.readyToCreate()}
				        loadingPosition="start"
				        startIcon={<SaveIcon />}
				        variant="contained"
				        onClick={() => create()}>
				        Crear
				      </LoadingButton>
		          </ThemeProvider>
		        </DialogActions>
	      	</Dialog>
        </div>
	)

}